<template>
  <v-form>
    <v-container>
      <div style="height: 30px;"></div>

      <v-card>
        <v-container>
          <v-select
            v-model="selectedWarehouse"
            :items="warehouses"
            label="倉庫選択"
            item-text="warehouseName"
            v-on:change="selectWarehouse()"
            return-object
          ></v-select>
        </v-container>
      </v-card>

      <div style="height: 30px;"></div>

      <v-card v-if="dispWarehouseItems">
        <v-container>
          <v-card-title class="title-highlight">
            {{ selectedWarehouse.warehouseName }}棚卸在庫
          </v-card-title>

          <!-- 선형차트 표시 영역 -->
          <div style="height:500px; margin-bottom:20px;" v-if="warehouseItems.length > 0">
            <LineChart :chart-data="chartData" :chart-options="chartOptions" style="height:500px; width:100%;"  />
          </div>

          <v-layout>
            <v-flex xs6>
              <v-text-field v-model.number="minStock" label="最小在庫数量"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field v-model.number="maxStock" label="最大在庫数量"></v-text-field>
            </v-flex>
          </v-layout>

          <div style="height: 20px;"></div>

          <!-- 파일 선택 -->
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="fileName"
                label="ファイル"
                prepend-icon="attach_file"
                hint="CSVファイル"
                v-validate="'required'"
                @click="pickFile"
              ></v-text-field>

              <input
                ref="file"
                type="file"
                style="display: none"
                accept=".csv, .xls"
                @change="onFileChange($event)"
              />
            </v-flex>
          </v-layout>

          <!-- 버튼 -->
          <v-layout row wrap>
            <v-flex xs12 sm6 class="pr-1">
              <v-btn
                block
                color="success"
                dark
                :loading="loading"
                @click="fileUpload()"
              >
                <v-icon dark left>cloud_upload</v-icon>
                アップロード
              </v-btn>
            </v-flex>

            <v-flex xs12 sm6 class="pl-1">
              <v-btn
                block
                color="primary"
                dark
                @click="downloadCsv()"
              >
                <v-icon dark left>get_app</v-icon>
                {{ $t('download-btn') }}
              </v-btn>
            </v-flex>
          </v-layout>          
          
          <div style="height: 20px;"></div>
          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="商品名検索"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6 sm6>
              <v-switch label="廃番商品も表示する" color="info" value="info" hide-details v-model="dispDeleted"></v-switch>
            </v-flex>
          </v-layout>
          <div style="height: 20px;"></div>

          <v-data-table
            :headers="headers"
            :items="warehouseItems"
            class="elevation-1"
            hide-actions
            :customFilter="customFilter"
            :search="search"
            style="width: 100%; margin: 15px 0 0;"            
          >
            <template v-slot:items="props">
              <tr v-if="dispDeleted === 'info' || (dispDeleted !== 'info' && '0' === props.item.isDeleted) || props.item.stockQuantity < 0 "
                v-bind:class="{
                  'deleted-class-name': props.item.isDeleted == '1' ? true : false,
                  'out-stock-class-name': props.item.stockQuantity < 0 ? true : false,
                  'changed-class-name': props.item.isChanged                  
                }"
              >
                <td class="text-xs-center px-2">{{ props.item.janCode }}</td>
                <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                <td class="text-xs-left px-2">{{ props.item.unitPrice }}</td>
                <td class="text-xs-left px-2">{{ props.item.createdAt }}</td>
                <td class="text-xs-left px-2">{{ props.item.updatedAt }}</td>
                
                <td class="text-xs-center px-2" v-if="(props.item.warehouseId === 24 || (user.userGroup !== '物流部' && user.userGroup != 'システムデザイン部' ))">
                  {{ props.item.stockQuantity }}
                </td>
                <!-- 물리재고수 -->
                <td class="stock-column">
                  <input
                    type="number"
                    v-model.number="props.item.stockQuantity"
                    min="0"
                    class="stock-input"
                    @change="editItem(props.item)"
                  />
                </td>

                <!-- 보관재고수 -->
                <td class="stock-column">
                  <input
                    type="number"
                    v-model.number="props.item.quantityToKeep"
                    min="0"
                    class="stock-input"
                    @change="editItem(props.item)"
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-container>
      </v-card>

      
      <!-- 버튼 영역 -->
      <div class="footer-btns">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>
        <v-btn v-if="(this.selectedWarehouse.warehouseId != 24 && (user.userGroup == '物流部' || user.userGroup == 'システムデザイン部' )) && this.warehouseItems.length > 0 " 
          block
          color="warning"
          dark
          :disabled="saveButton"
          @click="updateStockQuantity()"
        >
          確定する
        </v-btn>        
      </div>

    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
import { Line } from 'vue-chartjs'

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
)

export default {
  components: {
    LineChart: Line,   // 이름을 LineChart로 등록    
  },
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent);
    // 저장버튼을 표시하지 않는다
    this.saveButton = true; 
    // 창고정보 가져오기
    this.getWarehouseInfo();
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
    chartData() {
      if (!this.warehouseItems || this.warehouseItems.length === 0) {
        return { labels: [], datasets: [] }
      }

      const filtered = this.warehouseItems.filter(
        item =>
          item.stockQuantity >= this.minStock &&
          item.stockQuantity <= this.maxStock
      )

      // 전체 상품명
      const fullItemNames = filtered.map(item => item.itemName || '')

      // X축 표시용 상품명: 10글자 초과 시 ... 표시
      const shortenedItemNames = fullItemNames.map(itemName => {
        return itemName.length > 10
          ? itemName.substring(0, 10) + '...'
          : itemName
      })

      return {
        labels: shortenedItemNames,
        datasets: [
          {
            label: '在庫数量',
            data: filtered.map(item => item.stockQuantity),

            // 툴팁에서 사용할 전체 상품명
            fullItemNames: fullItemNames,

            borderColor: '#42A5F5',
            backgroundColor: 'rgba(66,165,245,0.2)',
            tension: 0.3,
            fill: true
          }
        ]
      }
    }
  },
  methods: {
    getWarehouseInfo() {
      ServerApiCallService.warehouseInfo()
        .then(response => {
          let resWarehouses = response.data.warehouses;

          // 치바창고만 화면에 보이게 한다
          // 12/3일 테스트 창고 25번도 보이게 수정
          for (let i=0; i<resWarehouses.length; i++) {
            if (resWarehouses[i].warehouseId == '14' || resWarehouses[i].warehouseId == '21' || resWarehouses[i].warehouseId == '24' || resWarehouses[i].warehouseId == '25' || resWarehouses[i].warehouseId == '31') {
              this.warehouses.push(resWarehouses[i]);
            }
          }

          this.warehouses.forEach(function(row, index) {
            if (row.isDeleted === '1') {
              this.warehouses.warehouses.splice(index, 1)
            }
          })

          this.warehouses.sort(function(a, b) {
            if (a.warehouseId > b.warehouseId) return 1
            if (a.warehouseId < b.warehouseId) return -1
            // a must be equal to b
            return 0
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },    
    selectWarehouse() {
      // 창고를 선택했을때 
      console.log('selectWarehouse')

      this.dispWarehouseItems = true
      this.saveButton = false; // 저장버튼 표시 flag

      // 창고의 상품을 가져오기
      this.getWarehouseRealtimeStocktaking()
    },
    customFilter(items, search) {
      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemName.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getWarehouseRealtimeStocktaking() {

      let request = {
        warehouseId: this.selectedWarehouse.warehouseId,
      }

      ServerApiCallService.getWarehouseRealtimeStocktaking(request)
        .then(response => {
          this.warehouseItems = response.data.warehouseItems
                   
          this.warehouseItems.forEach(function(row) {
            // 단가에 콤마를 붙이기
            let price = row.unitPrice;
            row.unitPrice = Number(price).toLocaleString();
            // 생성날짜는 초까지 보이기
            row.createdAt = row.createdAt.substr(0, 16)
            // 변경날짜는 초까지 보이기
            if (row.updatedAt != null) {
              row.updatedAt = row.updatedAt.substr(0, 16)
            }
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    editItem(item) {
      console.log('editItem');

      // 중복된 상품은 재고와 보관재고 수량만 업데이트 한다
      let bol = false;
      if (this.editedItem.length > 0) {
        for (let i=0; i<this.editedItem.length; i++) {
          if (this.editedItem[i].itemCode == item.itemCode) {
            this.editedItem[i].stockQuantity = item.stockQuantity
            this.editedItem[i].quantityToKeep = item.quantityToKeep
            bol = true;
          }
        }

        // 상품이 등록되어 있지 않은 경우
        if (!bol) {
          this.editedItem.push(item);  
        }
      } else {
        // 처음 상품을 등록할 경우
        this.editedItem.push(item);
      }
    },
    updateStockQuantity() {
      console.log('updateStockQuantity')

      let request=[];      
      for (let i=0; i<this.editedItem.length; i++) {

        if (this.editedItem[i].stockQuantity == null || this.editedItem[i].stockQuantity == "") {
          this.editedItem[i].stockQuantity = 0;
        }
        if (this.editedItem[i].quantityToKeep == null || this.editedItem[i].quantityToKeep == "") {
          this.editedItem[i].quantityToKeep = 0;
        }
        
        let obj = {
          warehouseId: this.selectedWarehouse.warehouseId,
          itemCode: this.editedItem[i].itemCode,
          stockQuantity: this.editedItem[i].stockQuantity,
          quantityToKeep: this.editedItem[i].quantityToKeep,
          type: "update"
        }
        
        request.push(obj);
      }

      ServerApiCallService.updateStockQuantity(request)
        .then(response => {
          // 초기화
          this.editedItem = []          
          // 업데이트 후 창고의 아이팀을 가져오기
          this.getWarehouseRealtimeStocktaking()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
      
      this.getWarehouseInfo()
    },
    downloadCsv() {
      let request = {
        warehouseId: this.selectedWarehouse.warehouseId,
      }

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false,
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .post('/admin/chiba-stock-download', request, {
          responseType: 'blob',
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.selectedWarehouse.warehouseName + '_棚卸在庫.csv'
          link.click()
        })
    },
    pickFile() {
      this.$refs.file.click()
    },
    onFileChange(e) {
      // const files = e.target.files
      this.targetFile = e.target.files[0]

      if (this.targetFile !== undefined) {
        this.fileName = this.targetFile.name
      }
    },
    fileUpload() {
      console.log('fileUpload')
      let thisObj = this
      // FormData を利用して File を POST する
      let formData = new FormData()
      formData.append('uploadFile', this.targetFile)
      formData.append('charsetName', this.fileFormat)
      formData.append('warehouseId', this.selectedWarehouse.warehouseId)

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }
      })

      thisObj.loading = true
      ServerApiCallService.sendWarehouseRealtimeStockFile(formData, sendContext)
        .then(response => {
          // 버튼의 빙글빙글 돌게 하는거
          thisObj.loading = false
          // 초기화면
          // this.getWarehouseRealtimeStocktaking()
        })
        .catch(error => {
          thisObj.loading = false
        })
    },
  },
  data() {
    return {
      fileName: '',
      fileFormat: 'SHIFT-JIS',
      editedItem: [],
      warehouses: [],
      loading: false,
      dispWarehouseItems: false,
      selectedWarehouse: [],
      search: '',
      warehouseItems: [],
      saveButton: true,
      dispDeleted: '',      
      headers: [
        {
          text: 'Jan code',
          align: 'left',
          value: 'itemCode',
          width: '5%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.product-name'),
          align: 'left',
          value: 'itemName',
          width: '20%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.unit-price'),
          align: 'left',
          value: 'unitPrice',
          width: '20%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.created-at'),
          align: 'left',
          value: 'createdAt',
          width: '20%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.updated-at'),
          align: 'left',
          value: 'updatedAt',
          width: '20%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: this.$t('sales.stock-quantity'),
          align: 'center',
          sortable: false,
          value: 'stockQuantity',
          width: '15%',
          fixed: true,
          class: 'text-xs-center px-2 stock-header'
        },
        {
          text: this.$t('sales.quantity-to-keep'),
          align: 'center',
          sortable: false,
          value: 'quantityToKeep',
          width: '15%',
          fixed: true,
          class: 'text-xs-center px-2 stock-header'
        }
      ],
      minStock: -10,
      maxStock: -1,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'top'
          },
          title: {
            display: true,
            text: '商品別在庫数量(折れ線グラフ)'
          },
          tooltip: {
            callbacks: {
              title: function(context) {
                if (!context || context.length === 0) {
                  return ''
                }

                const dataIndex = context[0].dataIndex
                const fullItemNames = context[0].dataset.fullItemNames

                return fullItemNames && fullItemNames[dataIndex]
                  ? fullItemNames[dataIndex]
                  : context[0].label
              },
              label: function(context) {
                return '在庫数量: ' + context.formattedValue
              }
            }
          }
        },
        scales: {
          x: {
            ticks: {
              autoSkip: true,      // 자동 생략
              maxTicksLimit: 15,   // 최대 표시 라벨 수
              maxRotation: 90,     // 최대 회전 각도
              minRotation: 60,     // 최소 회전 각도
            }
          },
          y: {
            beginAtZero: true,
            ticks: {
              stepSize: 1000,        // 1000단위
              callback: function (value) {
                // 1000단위 콤마
                return value.toLocaleString();
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style>
.deleted-class-name {
  background-color: #b3b3b3;
}
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ffcccc;
}
.out-stock-class-name {
  background-color: #ed2939;
}
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.stock-header {
  text-align: center !important;
}
.stock-column {
  text-align: center !important;
  vertical-align: middle !important;
}
.stock-input {
  display: block;
  width: 90px;
  height: 36px;
  margin: 0 auto;
  padding: 4px 8px;
  border: 1px solid #9e9e9e;
  border-radius: 4px;
  background-color: #ffffff;
  color: #333333;
  font-size: 14px;
  text-align: right;
  box-sizing: border-box;
}

.stock-input:focus {
  border-color: #1976d2;
  outline: none;
  box-shadow: 0 0 0 1px #1976d2;
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>